<div class="logo-container" *ngIf="company.logoBase64">
  <img
    [src]="'data:image/png;base64,' + company.logoBase64"
    alt="{{ company.name }} logo"
    class="company-logo"
  />
</div>

<button mat-icon-button (click)="onClose()" class="close-btn">
  <mat-icon>close</mat-icon>
</button>

@if (company.badge) {
  <h2 mat-dialog-title class="company-name">{{ company.name }} <mat-icon class="icon-badge">workspace_premium</mat-icon> </h2>
}
@else {
   <h2 mat-dialog-title class="company-name">{{ company.name }}</h2>
}



<p class="company-description"> {{company.description}} </p>

<mat-dialog-content class="horizontal-layout">
  <div class="top-row">
    <!-- Info Base -->
    <div class="column basic-info">
      <h3>{{ 'company-modal.info-base' | translate}}</h3>
      <div class="info-base">
        <div>
        <p><strong>{{ 'company-modal.country' | translate}}:</strong> {{ company.country?.name || company.city?.country?.name || 'N/A' }}</p>
        <p><strong>{{ 'company-modal.city' | translate}}:</strong> {{ company.city?.name || 'N/A' }}</p>
        <p><strong>{{ 'company-modal.email' | translate}}:</strong> {{ company.email }}</p>
        <p><strong>{{ 'company-modal.sector' | translate}}:</strong> {{ company.sector?.name || 'N/A' }}</p>
        </div>
        <div>
        <p><strong>{{ 'company-modal.address' | translate}}:</strong> {{ company.address || 'N/A' }}</p>
        <p><strong>{{ 'company-modal.badge' | translate}}:</strong> {{ company.badge === true ? 'Si' : (company.badge === false ? 'No' : 'N/A') }}</p>
        <p><strong>{{ 'company-modal.inclusion-index' | translate}}:</strong> {{ company.inclusionIndex?.toFixed(2) || 'N/A' }}</p>
        </div>
      </div>
    </div>

    <!-- Dimension Scores -->
    <div class="column dimension-scores" *ngIf="company.dimensionScores">
      <h3>{{ 'company-modal.dimension-scores' | translate}}</h3>
      <ul>
        <li *ngFor="let key of company.dimensionScores | keyvalue">
          <span class="dim-key">{{ key.key }}:</span>
          <span class="dim-value">{{ key.value.toFixed(2) }}</span>
        </li>
      </ul>
    </div>
  </div>

  <!-- Internships Section -->
  <div class="available-internships" *ngIf="internships.length">
    <div class="internships-header">
      <h3>{{ 'company-modal.available-internships' | translate}}</h3>
    </div>

    <!-- Search Filter -->
    <div class="filter-container">
      <div class="search-box">
        <mat-icon class="search-icon">search</mat-icon>
        <input
          type="text"
          [(ngModel)]="searchFilter"
          (input)="applyFilter()"
          placeholder="Search by title, position, department..."
          class="search-input"
        />
      </div>
      <button class="clear-filter-btn" (click)="clearFilters()" *ngIf="searchFilter">
        <mat-icon>clear</mat-icon>
      </button>
    </div>

    <!-- Internships Table -->
    <div class="table-container" *ngIf="filteredInternships.length > 0; else noResults">
      <table mat-table [dataSource]="filteredInternships" class="internships-table">

        <!-- Title Column -->
        <ng-container matColumnDef="internshipTitle">
          <th mat-header-cell *matHeaderCellDef>{{ 'company-modal.title' | translate}}</th>
          <td mat-cell *matCellDef="let element" [class.empty-title]="!element.internshipTitle">
            <span class="title-content">
              {{ element.internshipTitle || 'Internship Position' }}
            </span>
          </td>
        </ng-container>

        <!-- Position Column -->
        <ng-container matColumnDef="position" class="hide-mobile">
          <th mat-header-cell *matHeaderCellDef>{{ 'company-modal.position' | translate}}</th>
          <td mat-cell *matCellDef="let element">{{ element.position }}</td>
        </ng-container>

        <!-- Department Column -->
        <ng-container matColumnDef="department" class="hide-mobile">
          <th mat-header-cell *matHeaderCellDef>{{ 'company-modal.department' | translate}}</th>
          <td mat-cell *matCellDef="let element">{{ element.department }}</td>
        </ng-container>

        <!-- Country Column -->
        <ng-container matColumnDef="country">
          <th mat-header-cell *matHeaderCellDef>{{ 'company-modal.country' | translate}}</th>
          <td mat-cell *matCellDef="let element">{{ element.country?.name || element.city?.country?.name || 'N/A' }}</td>
        </ng-container>

        <!-- City Column -->
        <ng-container matColumnDef="city">
          <th mat-header-cell *matHeaderCellDef>{{ 'company-modal.city' | translate}}</th>
          <td mat-cell *matCellDef="let element">{{ element.city?.name || 'N/A' }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>{{ 'company-modal.email' | translate}}</th>
          <td mat-cell *matCellDef="let element"> {{ element.email || 'N/A' }} </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>{{ 'company-modal.details' | translate}}</th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button class="details-btn" (click)="viewDetails(element)" matTooltip="View details">
              <mat-icon>info</mat-icon>
            </button>
            <button mat-icon-button class="details-btn" (click)="contactCompany(element)" matTooltip="Contact">
              <mat-icon>mail</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <ng-template #noResults>
      <div class="no-results">
        <p>{{ 'company-modal.not-found' | translate}}</p>
      </div>
    </ng-template>
  </div>


</mat-dialog-content>


